import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconPhoneCloudBlack({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<defs>
				<path id="a" d="M.062.12H4.15v6.368H.062z" />
				<path id="c" d="M.104.06h8.919v4.488H.104z" />
			</defs>
			<g fill="none" fillRule="evenodd">
				<path
					fill="#000"
					fillRule="nonzero"
					d="M12.902 18.943a.52.52 0 0 1-.521.514.52.52 0 0 1-.522-.514c0-.284.234-.514.522-.514s.52.23.52.514"
				/>
				<path
					fill="#000"
					fillRule="nonzero"
					d="M9.83 8.834c-.224 0-.407.15-.407.333v10.295c0 .183.183.332.408.332h5.1c.224 0 .407-.149.407-.332V9.167c0-.183-.183-.333-.408-.333zm5.1 11.652h-5.1c-.605 0-1.097-.46-1.097-1.024V9.167c0-.565.492-1.024 1.098-1.024h5.1c.605 0 1.098.46 1.098 1.024v10.295c0 .564-.493 1.024-1.099 1.024"
				/>
				<path
					fill="#DB0C0C"
					fillRule="nonzero"
					d="M6.304 13.206C4.482 13.206 3 11.786 3 10.04s1.482-3.166 3.304-3.166c.196 0 .354.152.354.34 0 .187-.158.34-.354.34-1.431 0-2.595 1.115-2.595 2.486 0 1.37 1.164 2.486 2.595 2.486.196 0 .354.152.354.34a.347.347 0 0 1-.354.339"
				/>
				<g transform="translate(16.97 6.718)">
					<mask id="b" fill="#fff">
						<use xlinkHref="#a" />
					</mask>
					<path
						fill="#DB0C0C"
						fillRule="nonzero"
						d="M.826 6.488a.347.347 0 0 1-.354-.34c0-.187.159-.339.354-.339 1.443 0 2.615-1.123 2.615-2.505S2.27.8.826.8Q.645.8.464.824a.355.355 0 0 1-.4-.29A.343.343 0 0 1 .369.15Q.597.12.826.12C2.66.12 4.15 1.548 4.15 3.304S2.66 6.488.826 6.488"
						mask="url(#b)"
					/>
				</g>
				<g transform="translate(5.846 3)">
					<mask id="d" fill="#fff">
						<use xlinkHref="#c" />
					</mask>
					<path
						fill="#DB0C0C"
						fillRule="nonzero"
						d="M.459 4.548q-.018 0-.036-.002a.343.343 0 0 1-.317-.37C.346 1.829 2.388.06 4.852.06c1.69 0 3.27.87 4.122 2.27a.33.33 0 0 1-.127.465.36.36 0 0 1-.484-.123C7.636 1.48 6.292.74 4.852.74 2.753.739 1.016 2.245.81 4.242a.35.35 0 0 1-.351.306"
						mask="url(#d)"
					/>
				</g>
				<path
					fill="#DB0C0C"
					fillRule="nonzero"
					d="M17.387 7.56a.35.35 0 0 1-.347-.272c-.187-.876-1.001-1.511-1.936-1.511q-.256 0-.5.06a.356.356 0 0 1-.432-.242.34.34 0 0 1 .253-.414 2.8 2.8 0 0 1 .679-.083c1.27 0 2.376.864 2.63 2.054a.34.34 0 0 1-.276.4.4.4 0 0 1-.071.007M7.36 13.206H6.304a.347.347 0 0 1-.354-.34c0-.187.158-.34.354-.34H7.36c.195 0 .354.153.354.34s-.159.34-.354.34m10.437 0h-.863a.347.347 0 0 1-.355-.34c0-.187.159-.34.355-.34h.863c.196 0 .355.153.355.34s-.159.34-.355.34"
				/>
				<path
					fill="#000"
					fillRule="nonzero"
					d="M15.684 17.914H9.078c-.19 0-.345-.115-.345-.257s.154-.257.345-.257h6.606c.19 0 .345.115.345.257s-.155.257-.345.257m0-7.714H9.078c-.19 0-.345-.115-.345-.257s.154-.257.345-.257h6.606c.19 0 .345.115.345.257s-.155.257-.345.257"
				/>
			</g>
		</svg>
	);
}
